import React from "react";
import { useLocation } from "react-router-dom";
import CampaignDetailPage from "./CampaignDetailPage";

const CampaignDetailWrapper = () => {
  const location = useLocation();
  const initialCampaign = location.state?.campaign;

  return <CampaignDetailPage initialCampaign={initialCampaign} />;
};

export default CampaignDetailWrapper;
